// Component for editing user account information
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const MyAccountEdit = () => {
    const [formData, setFormData] = useState({
        name: '',
        surname: '',
        email: '',
        password: '',
        age: '',
        favorite_colors: '',
        profile_picture_url: '',  // Field to hold the new file
    });
    const [previewProfilePic, setPreviewProfilePic] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const token = localStorage.getItem('token');
                const response = await axios.get('http://localhost:3000/api/users/me', {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setFormData({
                    ...response.data,
                    profile_picture_url: '' // Clear the file input field for new file uploads
                });
                setPreviewProfilePic(response.data.profile_picture_url); // Set initial preview
            } catch (error) {
                console.error('Error fetching user data:', error);
            }
        };
        fetchUser(); // Fetch user data on load
    }, []);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setFormData({ ...formData, profile_picture_url: file });
        setPreviewProfilePic(URL.createObjectURL(file)); // Update image preview instantly
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem('token');

            const formDataToSend = new FormData();
            formDataToSend.append('name', formData.name);
            formDataToSend.append('surname', formData.surname);
            formDataToSend.append('email', formData.email);
            if (formData.password) {
                formDataToSend.append('password', formData.password);
            }
            formDataToSend.append('age', formData.age);
            formDataToSend.append('favorite_colors', formData.favorite_colors);
            if (formData.profile_picture_url && formData.profile_picture_url instanceof File) {
                formDataToSend.append('profile_picture', formData.profile_picture_url);
            }

            await axios.put('http://localhost:3000/api/users/me', formDataToSend, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                },
            });

            navigate('/my-account');
        } catch (error) {
            console.error('Error updating account:', error);
        }
    };

    return (
        <div className="my-account-container">
            <div className="account-card">
                <div className="profile-picture">
                    <p><label htmlFor="profile_picture_url" className="file-upload-label"><strong>Current Profile Picture</strong></label></p>
                    {previewProfilePic && (
                        <img 
                            src={previewProfilePic} 
                            alt="Profile Preview" 
                            className="profile-img"
                        />
                    )}
                    <p><input 
                        type="file" 
                        id="profile_picture_url"
                        name="profile_picture_url" 
                        onChange={handleFileChange}
                        className="file-input"
                    /></p>
                </div>
                <div className="user-details">
                    <form onSubmit={handleSubmit} className="edit-form" encType="multipart/form-data">
                        <label><strong>Name:</strong>
                            <input 
                                type="text" 
                                name="name" 
                                value={formData.name} 
                                onChange={handleChange} 
                                placeholder="Your First Name"
                                className="input-field"
                            />
                        </label>
                        <label><strong>Surname:</strong>
                            <input 
                                type="text" 
                                name="surname" 
                                value={formData.surname} 
                                onChange={handleChange} 
                                placeholder="Your Last Name"
                                className="input-field"
                            />
                        </label>
                        <label><strong>Email:</strong>
                            <input 
                                type="email" 
                                name="email" 
                                value={formData.email} 
                                onChange={handleChange} 
                                placeholder="E-mail"
                                className="input-field"
                            />
                        </label>
                        <label><strong>Password:</strong>
                            <input 
                                type="password" 
                                name="password" 
                                onChange={handleChange} 
                                placeholder="New password" 
                                className="input-field"
                            />
                        </label>
                        <label><strong>Age:</strong>
                            <input 
                                type="number" 
                                name="age" 
                                value={formData.age} 
                                onChange={handleChange} 
                                placeholder="Your age"
                                className="input-field"
                            />
                        </label>
                        <label><strong>Favorite Color\-s:</strong>
                            <input 
                                type="text" 
                                name="favorite_colors" 
                                value={formData.favorite_colors} 
                                onChange={handleChange} 
                                placeholder="Favorite Colors (comma separated)"
                                className="input-field"
                            />
                        </label>
                        <div className="account-actions">
                            <button type="submit" className="edit-btn">
                                <i className="fa fa-save"></i> 𝒰𝓅𝒹𝒶𝓉𝑒 𝒫𝓇𝑜𝒻𝒾𝓁𝑒
                            </button>
                            <button type="button" className="delete-btn" onClick={() => navigate('/my-account')}>
                                <i className="fa fa-times"></i> 𝒞𝒶𝓃𝒸𝑒𝓁
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default MyAccountEdit;